module.exports = __webpack_public_path__ + "img/progress-bar-for-react.32cf1093.png";